import { Text, View } from 'react-native'

import type { StatisticCardItem } from '../types/statistics'
import { STATISTICS_ICON_SIZE, StatisticsIcon } from '../assets/StatisticsIcons'
import {
  STAT_CARD_STYLE,
  TIMEFRAME_TEXT_STYLE,
  TITLE_TEXT_STYLE,
  VALUE_TEXT_STYLE,
} from '../constants/statistics.styles'

export function StatisticsMetricCard({
  title,
  value,
  timeframe,
  iconName,
}: StatisticCardItem) {
  return (
    <View style={STAT_CARD_STYLE}>
      <View
        style={{
          width: STATISTICS_ICON_SIZE,
          height: STATISTICS_ICON_SIZE,
          marginBottom: 5,
          marginLeft: -2,
        }}
      >
        <StatisticsIcon name={iconName} />
      </View>
      <Text style={[TITLE_TEXT_STYLE, { marginBottom: 2 }]}>{title}</Text>
      <Text style={[VALUE_TEXT_STYLE, { marginBottom: 4 }]}>{value}</Text>
      <Text style={TIMEFRAME_TEXT_STYLE}>{timeframe}</Text>
    </View>
  )
}
